var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 56,
    viewBox: "0 0 91 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5527 5.98636H33.0527V50.0135H57.5527V5.98636Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6088 28C34.605 23.7599 35.5658 19.5744 37.4186 15.7605C39.2714 11.9466 41.9677 8.60425 45.3032 5.98641C41.1726 2.73968 36.2119 0.720595 30.9881 0.159916C25.7642 -0.400763 20.488 0.519573 15.7626 2.81577C11.0371 5.11197 7.05291 8.69138 4.26553 13.1448C1.47815 17.5983 0 22.7462 0 28C0 33.2538 1.47815 38.4017 4.26553 42.8552C7.05291 47.3086 11.0371 50.888 15.7626 53.1842C20.488 55.4804 25.7642 56.4008 30.9881 55.8401C36.2119 55.2794 41.1726 53.2603 45.3032 50.0136C41.9677 47.3957 39.2715 44.0534 37.4187 40.2395C35.5659 36.4256 34.605 32.2401 34.6088 28V28Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6055 28C90.6057 33.2538 89.1277 38.4016 86.3405 42.8551C83.5532 47.3085 79.5692 50.8879 74.8438 53.1842C70.1184 55.4804 64.8423 56.4008 59.6186 55.8401C54.3948 55.2794 49.4342 53.2603 45.3037 50.0136C48.6363 47.3931 51.3304 44.0502 53.1829 40.2369C55.0354 36.4236 55.998 32.2395 55.998 28C55.998 23.7605 55.0354 19.5764 53.1829 15.7631C51.3304 11.9498 48.6363 8.60689 45.3037 5.9864C49.4342 2.73967 54.3948 0.72058 59.6186 0.159908C64.8423 -0.400763 70.1184 0.519613 74.8438 2.81584C79.5692 5.11206 83.5532 8.69147 86.3405 13.1449C89.1277 17.5984 90.6057 22.7462 90.6055 28V28Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9333 45.3504V44.4491H88.2967V44.2654H87.3711V44.4491H87.7347V45.3504H87.9333ZM89.7303 45.3504V44.2636H89.4466L89.1203 45.0112L88.7938 44.2636H88.5099V45.3504H88.7103V44.5306L89.0163 45.2374H89.2241L89.5301 44.5289V45.3504H89.7303Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.c9a40578f6787bc4a821600996a2c282.svg";
export { ForwardRef as ReactComponent };